/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import SignatureIcon from "dc-icons/viewer2021/SDC_AddSignatureTool_18_N.svg";
import SignatureValidIcon from "dc-icons/chrome_extension/SDC_AddSignatureValid_18_N.svg";
import SignatureInvalidIcon from "dc-icons/chrome_extension/SDC_AddSignatureInvalid_18_N.svg";
import SignatureUnknownIcon from "dc-icons/chrome_extension/SDC_AddSignatureUnknown_18_N.svg";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import { VALIDATION_STATUS } from "constants/constants";

const DigSigRHPIcon = ({ validationSummary }) => {
  let icon = null;
  let iconName = "";

  const { status } = validationSummary || {};
  iconName = status ? `signature-icon-${status}` : "signature-icon";

  switch (status) {
    case VALIDATION_STATUS.VALID:
      icon = SignatureValidIcon;
      break;
    case VALIDATION_STATUS.INVALID:
      icon = SignatureInvalidIcon;
      break;
    case VALIDATION_STATUS.UNKNOWN:
      icon = SignatureUnknownIcon;
      break;
    default:
      icon = SignatureIcon;
      break;
  }

  return (
    <span data-testid={iconName}>
      <CustomIcon url={icon} />
    </span>
  );
};

export default DigSigRHPIcon;
